var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer green-txt caption text-uppercase font-weight-medium",attrs:{"color":"green"},on:{"click":_vm.goBack}},[_c('v-icon',{staticClass:"white--text",attrs:{"dense":"","color":"green"}},[_vm._v(" mdi-chevron-left ")]),_vm._v(" "+_vm._s(_vm.btnText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }